

























import { Component, Vue } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import DxTabs from 'devextreme-vue/tabs';
import { ITunnelGroup, TunnelGroupsClient } from '@/data/web-api-client';
import { TunnelGroupsTable, RawMaterialGroupsTable, AddTunnelGroupsDialog } from '../components';

@Component({
  components: {
    TunnelGroupsTable,
    RawMaterialGroupsTable,
    AddTunnelGroupsDialog,
    Card,
    DxTabs,
  },
})
export default class TunnelGroupsOverviewPage extends Vue {
  navIndex: number = 0;
  tunnelGroups: ITunnelGroup[] = [];

  private tunnelGroupsClient = new TunnelGroupsClient(undefined, this.$axios);

  private async created() {
    await this.loadData();
  }

  async loadData() {
    this.tunnelGroups = await this.tunnelGroupsClient.get();
  }

  get navbarItems() {
    var items = [
      { icon: 'fas fa-tasks', text: this.$t('objects.tunnelGroups.pluralCap'), visible: true },
      { icon: 'fas faw fa-table', text: this.$t('objects.rawMaterialGroups.pluralCap') },
    ];

    return items;
  }
}
